import { inject, injectable } from '~/container'
import { LocationSuggestionCustom } from '../domain/LocationSuggestions'
import { SuggestionsGeoService } from '../services'
import { GeoSearchService } from '../../../../geo/GeoSearchService'

@injectable()
export default class FetchLocationGeoSuggestions
implements SuggestionsGeoService
{
  @inject(GeoSearchService)
  private getSearchService: GeoSearchService

  async fetch(
    input: string,
    langCode: string,
  ): Promise<LocationSuggestionCustom[]> {
    return this.getSearchService.get(input, langCode)
  }
}
